<template>
  <div>
    <div style="margin: 12px">
      <el-radio-group v-model="insuranceAgent" @change="changeJumpUrl">
        <el-radio v-for="option in insuranceAgents" :key="option.code" :label="option.code">{{ option.chineseName }}</el-radio>
      </el-radio-group>
    </div>
    <div style="flex-grow: 1">
      <iframe
        ref="myIframe"
        same-site="none"
        :src="innerJumpUrl"
        :style="{ border: 'none',marginLeft: '10px' }"
        width="99%"
        height="98%"
      />
    </div>
  </div>
</template>

<script>

import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import { getJumpUrl } from '@/api/external/insureInfo'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { INSURANCE_AGENT } from '@/class/cargo/model/parameters/InsuranceConstants'

export default {
  name: 'AgentIframe',
  components: {},
  props: {
    jumpUrl: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      insuranceAgents: InsuranceConstants.INSURANCE_AGENT,
      insuranceAgent: '',
      innerJumpUrl: ''
    }
  },
  watch: {
    jumpUrl(newVal) {
      this.innerJumpUrl = newVal
    }
  },
  created() {
    this.insuranceAgent = LocalStorageUtilsNew.getConfiguration('RADIO_INSURANCE_AGENT')
    if (this.insuranceAgent) {
    } else {
      this.insuranceAgent = InsuranceConstants.XNHB.code
    }
    this.changeJumpUrl(this.insuranceAgent)
  },
  methods: {
    // 外部调用
    changeAgent(data) {
      this.insuranceAgent = data
      LocalStorageUtilsNew.setConfiguration('RADIO_INSURANCE_AGENT', data)
    },
    // 手动切换radio触发
    changeJumpUrl(agent) {
      LocalStorageUtilsNew.setConfiguration('RADIO_INSURANCE_AGENT', agent)
      const data = {
        insuranceAgent: agent,
        branchId: this.$store.getters.currentOfficeId,
        userId: this.$store.getters.userId,
        type: this.type
      }
      const loading = getLoading4Cxt(this)
      getJumpUrl(data).then(res => {
        if (res.ok) {
          this.innerJumpUrl = res.data
        }
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>>
